<template>
  <div class="table">
    <div class="container">
      <!-- <div class="handle-box">
                <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="130px">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('ssrManage.invitationCode')" prop="invitationCode">
                                <el-input v-model="queryCondition.invitationCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('ssrManage.supplierName')" prop="supplierName">
                                <el-input v-model="queryCondition.supplierName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('ssrManage.isSupplier')" prop="supplierstatus">
                                <el-select v-model="queryCondition.supplierstatus" :placeholder="$t('common.sel')">
                                    <el-option label="是" value="FORMAL"></el-option>
                                    <el-option label="否" value="POTENTIAL"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="Category1" prop="categoryLevel1Id">
                                <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()">
                                    <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Category2" prop="categoryLevel2Id">
                                <el-select v-model="queryCondition.categoryLevel2Id" clearable>
                                    <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="center">
                        <el-col :span="4">
                            <el-button @click="queryData(1)"  type="primary">{{$t('common.search')}}</el-button>
                            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div> -->
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table style="margin-top:20px" :data="tableData" border highlight-current-row class="table" row-key="tmSupplierId" @selection-change="handleSelectionChange" ref="supplierSelectTabel">
        <el-table-column v-if="multipleSelectionFlag" sortable prop="tmSupplierId" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmSupplierId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="nameCn" :label="$t('settlementUnit.nameCn')"></el-table-column>
        <!--供应商名称-->
        <el-table-column prop="nameEn" :label="$t('settlementUnit.nameEn')"></el-table-column>
        <!--供应商英文名称-->
        <el-table-column prop="address" :label="$t('settlementUnit.detailAddress')"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { apiService } from "@/api/material/material-master-data";
import supplierApi from "@/api/supplier/supplier";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import unitApi from "@/api/unit/unit";
export default {
  name: 'supplier-sel-page',
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    },
    id: {
      type: String,
    }
  },
  data() {
    return {
      tableList: [],
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        invitationCode: null,
        supplierName: null,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        supplierstatus: '',
        tmSupplierId: '',
      },
      multipleSelection: [],
      supplierStatusList: [],
      categoryList1: [],
      categoryList2: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      radioVal: null,
    }
  },
  created() {
    this.queryData(1);
    this.getCategoryList()
  },
  watch: {
    visible() {
      this.$refs.supplierSelectTabel.clearSelection();
    }
  },
  methods: {
    //查询承运商
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      this.queryCondition.tmSupplierId = this.id;
      unitApi.getAddress(this.queryCondition, this.id).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
      // supplierApi.getResourceList(this.queryCondition).then((res) => {
      //     this.tableData = res.resultData;
      //     this.totalCount = res.totalCount;
      // })
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows);
      // if(this.selectRows.length==0){
      //     this.$message({message: "请选供应商", type: "warning"});
      // }else{
      //     this.$emit('subCallMethod', this.selectRows);
      // }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
  },
  extends: commonFunction
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
</style>
